import { assets } from './assets.const';
import { ModuleConst } from './moduleConst';

export interface sidebarInterface {
  label: string;
  path: string;
  img: string;
  isSubMenu: boolean;
  subMenuItems?: sidebarInterface[];
  sideBarId: number;
  isView?: boolean;
  isEdit?: boolean;
  isAdd?: boolean;
  isDelete?: boolean;

  pointerCount?: number;
  hasPointer?: boolean;
}

export const sideBar: sidebarInterface[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    img: assets.DashboardIconNew,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },
  {
    label: 'Bookings',
    path: '/manage-bookings/list/1/0/0',
    img: assets.BookingIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.ManageBookings,
    subMenuItems: [
      {
        label: 'Create Booking',
        path: '/updated-Booking-flow',
        img: assets.createBookingIcon,
        isSubMenu: false,
        sideBarId: +`${ModuleConst.ManageBookings}02`
      },
      {
        label: 'All Bookings',
        path: '/manage-bookings/list/1/0/0',
        img: assets.BookingIconNew,
        isSubMenu: false,
        sideBarId: +`${ModuleConst.ManageBookings}03`
      },
      {
        label: 'Approval Queue',
        path: '/manage-approvals/0',
        img: assets.approvalIcon,
        isSubMenu: false,
        sideBarId: +`${ModuleConst.ManageBookings}03`
      }
    ]
  },
  {
    label: 'User Management',
    path: '/manage-employee',
    img: assets.UsersIconNew,
    isSubMenu: false,
    sideBarId: ModuleConst.ManageEmployees
  },
  {
    label: 'Manage Sub-Admin',
    path: '/subadmin',
    img: assets.SubAdminIconNew,
    isSubMenu: false,
    sideBarId: ModuleConst.ManageSubAdmin
  },
  {
    label: 'Catalogues',
    path: '/catalogues',
    img: assets.cataloguesIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Catalogues
  },
  {
    label: 'Financials',
    path: '/manage-payouts',
    img: assets.FinancialIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.RevenueManagement
  },
  {
    label: 'Analytics',
    path: '/manage-analytics',
    img: assets.AnalyticIconNew,
    isSubMenu: false,
    sideBarId: ModuleConst.Analytics
  }
];

export const sideBar2: sidebarInterface[] = [
  {
    label: 'Settings',
    path: '/',
    img: assets.BookingIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.ManageSettings,
    subMenuItems: [
      {
        label: 'Roles Config',
        path: '/manage-config',
        img: assets.createBookingIcon,
        isSubMenu: false,
        sideBarId: +`${ModuleConst.ManageSettings}02`
      },
      {
        label: 'Manage Teams',
        path: '/manage-teams',
        img: assets.BookingIconNew,
        isSubMenu: false,
        sideBarId: +`${ModuleConst.ManageSettings}03`
      }
    ]
  },
  {
    label: 'Help & Support',
    path: '/contact-us',
    img: assets.ContactUsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ManageSettings
  }
];

type PointerMapConfig = {
  sideBarId: number;
  subLabel?: string;
};

export const POINTER_TYPE_MAP: Record<string, PointerMapConfig> = {
  CORPORATE_INVOICE_GENERATE: {
    sideBarId: ModuleConst.RevenueManagement
  },
  CORPORATE_BOOKING_APPROVAL_QUEUE: {
    sideBarId: ModuleConst.ManageBookings,
    subLabel: 'Approval Queue'
  },
  CORPORATE_BOOKING: {
    sideBarId: ModuleConst.ManageBookings,
    subLabel: 'All Bookings'
  },
  CORPORATE_BOOKING_EMPLOYEE: {
    sideBarId: ModuleConst.ManageBookings,
    subLabel: 'All Bookings'
  },
  UPDATE_BOOKING_APPROVAL_QUEUE: {
    sideBarId: ModuleConst.ManageBookings,
    subLabel: 'Approval Queue'
  }
};